<template>
  <router-link v-if="router" :to="to" class="challenge-button rounded-pill p-2">
    <slot></slot>
  </router-link>
  <button
    v-else
    class="challenge-button rounded-pill p-2"
    @click="$emit('click', $event)"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'CustomButton',
  props: {
    router: {
      type: Boolean,
      default: false,
    },
    to: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.challenge-button {
  background-color: #f8cb87;
  color: black !important;
  text-align: center;
  border: none;
  &:disabled {
    background-color: #decbb0;
    pointer-events: none;
  }
  &:focus {
    outline: none;
  }
  &:hover {
    text-decoration: none;
    background-color: #e7bd7c;
  }
}
</style>
